import { DEFAULT_REFETCH_INTERVAL, useCurrentUser } from '@mp/hooks';
import { graphql } from '@mp/graphql/generated';
import { type ResultOf } from '@graphql-typed-document-node/core';
import { useGraphQLQuery } from './useGraphQLRequest';

const NearFutureExpiringConditionsGql = graphql(`
  query ExpiringConditions($input: ConditionQueryInput) {
    conditions(input: $input) {
      id
      slug
      label
      payload
      condition_type
      display_category
      display_description
      condition_documents {
        id
        name
        category
        file
      }
      qualifications {
        id
        input_source
        instructions
        long_name
        slug
        admin_view_only
        qualification_type
        status
        qualification_attributes {
          id
          name
          field_type
          required
          data
          input_source
          active
          slug
        }
      }
    }
  }
`);

type NearFutureExpiringConditionsGqlResult = ResultOf<typeof NearFutureExpiringConditionsGql>;
export type NearFutureExpiringCondition = NonNullable<
  NearFutureExpiringConditionsGqlResult['conditions']
>[number];

type UseNearFutureExpiringConditionsInput = {
  refetch?: boolean;
};

type Return = {
  expiringConditions: NearFutureExpiringCondition[];
  isLoading: boolean;
};

export const useNearFutureExpiringConditions = ({
  refetch,
}: UseNearFutureExpiringConditionsInput = {}): Return => {
  const { currentUser } = useCurrentUser();

  const enabled = !!currentUser?.professional?.id;

  const { data, isLoading } = useGraphQLQuery<NearFutureExpiringConditionsGqlResult>({
    enabled,
    operationName: 'ExpiringConditions',
    refetchInterval: refetch ? DEFAULT_REFETCH_INTERVAL : undefined,
    query: NearFutureExpiringConditionsGql,
    variables: {
      input: {
        search: {
          expiring_conditions: {
            professional_id: currentUser?.professional?.id,
          },
        },
      },
    },
  });

  return {
    expiringConditions: data?.conditions ?? [],
    isLoading,
  };
};
